import React from 'react'
import { Form, Row, Col } from 'antd'
import { FormikProps, FormikValues } from 'formik'
import { number, object, setLocale, string } from 'yup'
import moment from 'moment'
import { DatePickerRange, SelectParticipant } from 'src/components/Formik'
import SelectOrganizationCurrentManager from 'src/components/Formik/select-organization-current-manager'

function getInitialValues() {
  return {
    ended_on: moment.utc().endOf('month').unix(),
    organization_id: '',
    started_on: moment.utc().startOf('month').unix(),
    status: null as string[]
  }
}

function getRenderForm() {
  return (formikProps: FormikProps<FormikValues>) => {
    return (
      <Form onSubmit={formikProps.handleSubmit}>
        <Row>
          <Col span={24}>
            <SelectOrganizationCurrentManager
              formikProps={formikProps}
              required
            />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <DatePickerRange
              formikProps={formikProps}
              label="web.reports.parameter.period.title"
              name={['started_on', 'ended_on']}
              placeholder={[
                'web.reports.parameter.period.placeholder-start',
                'web.reports.parameter.period.placeholder-end'
              ]}
              required
              showTime={false}
            />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <SelectParticipant
              formikProps={formikProps}
              label="web.reports.parameter.participant.title"
              name="participant"
              placeholder="web.reports.parameter.participant.placeholder"
              required={false}
            />
          </Col>
        </Row>
      </Form>
    )
  }
}

function getValidationSchema() {
  setLocale({
    mixed: {
      notType: 'common.required',
      required: 'common.required'
    }
  })

  return object().shape({
    ended_on: number().required().typeError(),
    organization_id: string().required(),
    participant: number().notRequired(),
    started_on: number().required().typeError()
  })
}

export { getRenderForm, getValidationSchema, getInitialValues }
